/**
 * Errors.js
 *
 * This file contains all the the route under error
 */
import View from '@/views/ErrorPages/ErrorPagesHome.vue';
import ApiError from '@general/js/components/errorPages/ApiError.vue';
import NotFound from '@general/js/components/errorPages/NotFound.vue';
import Unauthorized from '@general/js/components/errorPages/Unauthorized.vue';
import { ERROR_404_PAGE_NOT_FOUND, ERROR_OTHER, ERROR_UNAUTHORISED_ACCESS } from './routeNames';

export default [
  {
    path: '/:pathMatch(.*)*',
    redirect: {
      name: ERROR_404_PAGE_NOT_FOUND,
    },
  },
  {
    path: `/error`,
    component: View,
    meta: {
      title: 'Error',
    },
    children: [
      {
        path: '',
        name: ERROR_OTHER,
        component: ApiError,
        meta: {
          title: 'Error',
        },
      },
      {
        path: `/error/${ERROR_404_PAGE_NOT_FOUND}`,
        name: ERROR_404_PAGE_NOT_FOUND,
        component: NotFound,
        props: {
          isMemberPortal: true,
        },
        meta: {
          title: "Sorry, we couldn't find that page",
        },
      },
      {
        path: `/error/${ERROR_UNAUTHORISED_ACCESS}`,
        name: ERROR_UNAUTHORISED_ACCESS,
        component: Unauthorized,
        meta: {
          title: "Sorry, we can't show you the page you want",
        },
      },
    ],
  },
];
